

import * as yup from "yup";

export const Inputs = [
  {
    name: "phone",
    type: "text",
    inputType:"number",
    limit:11,

    icon: 'fas fa-mobile-alt fa-2x',
    placeholder: { ar: 'رقم الموبايل', en: "Phone Number" },
    col: "12",
  },
  {
    name: "password",
    type: "password",
    isPassword: true,
    icon: ['fas fa-eye fa-2x', 'fas fa-eye-slash fa-2x'],
    placeholder: { ar: 'كلمة المرور', en: "Password" },
    col: "12",
  },
  {
    name: 'rememberMe',
    type: 'checkbox',
    label: { ar: 'تذكرنى', en: 'Remember me' },
    col: '12'
  }

]

export const config = {
  url: '/signin',
  loginFlag: true,
  redirect: false,
  Sendbtn: { ar: 'دخول', en: 'Enter' },
  submitLabels: ['phone', 'password'],

}


export const Validation = yup.object().shape({
  phone: yup.string().required({ar:'يجب ادخال رقم الهاتف *',en:'Phone number is not valid *'}).typeError({ar:'يجب ادخال رقم الهاتف *',en:'Phone number is not valid *'}),
  password: yup.string().required({ar:"يجب ادخال كلمة المرور *",en:"Password is required *"}),

})